export default class Reward {
    constructor(userId, points, comment) {
        this.userId = userId
        this.points = points
        this.comment = comment
    }
}